import React, { memo, useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { THEME } from '../../constants/styles';
import { EMPLOYER_TYPE_AIRFORCE, EMPLOYER_TYPE_MED_RECRUITER } from '../../constants/employerTypes';

import { FormInput, FormHelpers, FieldLabel, CheckButtonList } from '../components';

const nameRef = React.createRef();
const slugRef = React.createRef();

const TYPE_ITEMS = [
  {
    id: EMPLOYER_TYPE_AIRFORCE,
    label: 'DOD',
    checked: false,
  },
  {
    id: EMPLOYER_TYPE_MED_RECRUITER,
    label: 'Med Recruiter',
    checked: false,
  },
];

const NameForm = memo((props) => {
  const employer = props.employer || {};
  const [name, setName] = useState(employer.name || null);
  const [slug, setSlug] = useState(employer.slug || null);
  const [type, setType] = useState(employer.uiConfig?.type || EMPLOYER_TYPE_AIRFORCE);
  const superadminEmails = employer.superadminEmails || null;

  useEffect(() => {
    const isValid = FormHelpers.validateFields([nameRef.current, slugRef.current]);
    props.onDataChange(
      {
        ...employer,
        name,
        slug,
        uiConfig: {
          ...employer.uiConfig,
          type,
        },
      },
      isValid
    );
  }, [name, slug, type]);

  return (
    <View style={{ marginBottom: 20 }}>
      <CheckButtonList
        items={TYPE_ITEMS}
        value={type}
        containerStyle={null}
        multi={false}
        disabled={!!employer?.employerId}
        scrollable={false}
        onValue={setType}
      />
      <FormInput
        ref={nameRef}
        value={name}
        label={'Name'}
        required={true}
        onChangeText={setName}
        controlled={true}
        autoCorrect={false}
      />
      {type === EMPLOYER_TYPE_AIRFORCE && (
        <FormInput
          ref={slugRef}
          value={slug}
          label={'Slug'}
          required={true}
          onChangeText={setSlug}
          controlled={true}
          autoCorrect={false}
        />
      )}

      {!!superadminEmails && (
        <View style={{ marginTop: 15 }}>
          <FieldLabel label="Super Admins" />
          <View style={{ marginTop: 5 }}>
            {superadminEmails.map((email) => (
              <Text style={[THEME.textRegular, { marginTop: 10 }]} key={email}>
                {email}
              </Text>
            ))}
          </View>
        </View>
      )}
    </View>
  );
});

export default NameForm;
